import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setQuestion, setChartQuestion, setDatasetChange } from '../../../src/actions/index';
import { getParameters } from './Helper';
import CallAPI from '../commonComponents/AxiosHelper';

function BreadcrumbComponent({ props, dataa, handleSync, onDashboardChange, currentPageName, stateData, dashboardTabArray, setQuestion, setChartQuestion , mobile, datasetTruncate,handleGlobalFilter}) {
    const propsData = props
    var chartData = dataa.alfred.chart_array.All;
    let spinnerSpan = <span className="spinner">
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>
    </span>
    let aTagStyle = { color: "black", fontWeight: "500", textTransform: "uppercase", cursor: "pointer" }
    let cursorPointerStyle = { cursor: "pointer" }
    let savedReportPage = location.pathname.includes('SavedReport')
    let syncDate = propsData?.dataSet?.last_sync_date
    var formattedDate = null
    var dateObj = null
    let fontSizeCss = jQuery(document).width() < mobile_width ? "15px":""  //increase font size for mobile breadcrumb 
    var time = null
    if (syncDate != null && syncDate != undefined && syncDate != '') {
        dateObj = syncDate.split(' ')
        time = dateObj[1]
        var date = new Date(dateObj[0]);
        formattedDate = date.toLocaleDateString("en-US", {
            day: "numeric",
            month: "numeric",
            year: "numeric",
        });
    }
    function trimNameLength(str, length) {
        if (str.length > length) {
            return str.substring(0, length) + "...";
        } else {
            return str;
        }
    }
    function handleAlfred(data = null, chart = null) {
        if (chart == true) {
            setChartQuestion({ alfredChartFlag: true })
        } else {
            const url = new URL(window.location);
            // const params = new URLSearchParams(url.search);
            // params.delete('question');
            // if (params.has('metric')) {
            //     params.set('metric', '');
            //   }
            //   if (params.has('property')) {
            //     params.set('property', '');
            //   }
            //   if (params.has('startDate')) {
            //     params.set('startDate', '');
            //   }
            //   if (params.has('endDate')) {
            //     params.set('endDate', '');
            //   }
            // url.search = params.toString();
            history.replaceState(null, '', url);
            setQuestion({ alfred_question: "" })
            handleSync(data,true)
        }
    }

    function fetchSampleQuestions() {
        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            toolId: propsData.dataSet.toolId,
            refresh: true,
            download: true ,
        }
        let url = "/app/downloadSampleQuestion"
        if (confirm("Please Confirm to Proceed!")) {
            isDataLoading(true)
            CallAPI('POST', url, params, null, 0, function (response) {
                if (response == true) {
                    isDataLoading(false)
                    alert("Questions prepared successfully!")
                } else if (response?.type == 'csv') {
                    isDataLoading(false)
                    let binaryData = [];
                    alert("Questions downloaded succesfully!")
                    let decodedData = atob(response.csvData)
                    binaryData.push(decodedData);
                    const link = document.createElement('a');
                    const fileURL = window.URL.createObjectURL(new Blob(binaryData, { type: "text/csv" }))
                    link.href = fileURL;
                    link.download = response.fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(fileURL);
                }else{
                    alert("Something went wrong!")
                }
            }, propsData.authData)
        }
    }
    const isPageNameValidForGlobalFilters = window.location.pathname=="/chart" ? false: ['summary', 'chart', 'report', 'pinboard',].indexOf(currentPageName) != -1;
    return (
        <>
            <div className="btn-group align-items-center ">
                {/* <i className={`icon refreshIcon fa fa-sync-alt  mg-r-6`} onClick={() => handleAlfred()} id="refreshIcon" style={cursorPointerStyle}></i> */}
                <button className={`dropdown-toggle btn text-truncate btn-sm btn-white dropdown-toggle tx-bold mg-t-2 mg-b-2 mg-r-12 d-flex justify-content-center align-items-center`}type="button" id="dropdownMenuButton" style={{ fontSize: "13px",maxWidth:"200px", minWidth:"100px" }} data-bs-toggle="dropdown" 
                    aria-expanded="false" title={syncDate != null && syncDate != undefined && syncDate != '' ? `This dataset was last refreshed on ${formattedDate} at ${time}` : null}  >
                    {trimNameLength(propsData.dataSet.name, mobile ? 15 : 20)}
                    {/* {propsData.dataSet.name} */}
                </button>     
                          
                 {/* {currentPageName == "pinboard" ?
                    <i className="fa fa-angle-right mg-l-5  mg-r-10"></i> : ""} */}

                    {/* <i className="fa fa-angle-right mg-l-5 mg-r-10"></i> */}
                <ul className="dropdown-menu" role="menu" id="breadcrumbDropdown">
                    <li>
                        {propsData.dataResult.map((innerData) =>
                            <div className='d-flex-row flex-nowrap'>
                                <a key={innerData.toolId} href='javascript:void(0)' className={`dropdown-item ${innerData.name === propsData.dataSet.name ? 'active' : ""}`} onClick={() => handleAlfred(innerData)}  style={{cursor: "pointer" , fontSize :fontSizeCss} } >
                                    {innerData.name}
                                </a>
                            </div>
                        )}
                    </li>
                </ul>
                {currentPageName == "pinboard" ? propsData?.dashboardUIType == 'tabs'
                    ? null
                    : <div className="btn-group align-items-center" >
                        <button className={`btn text-truncate btn-sm btn-white dropdown-toggle tx-bold mg-l-5 mg-t-2 mg-b-2 mg-r-12`} type="button" style={{ fontSize: "13px", maxWidth: "200px", minWidth: "100px", borderRadius:"3px" }} data-bs-toggle="dropdown" title={propsData.report_name} id={"aTagStyleactive"} >
                            {propsData.report_name
                                ? trimNameLength(propsData.report_name, mobile ? 8 : 20)
                                : spinnerSpan}
                        </button>
                        <ul className="dropdown-menu" role="menu" id="breadcrumbDropdown">
                            <li>
                                {dashboardTabArray.map((innerData) =>
                                    <a className={`dropdown-item ${innerData.dashboardName === propsData.report_name ? 'active' : ""}`} href='javascript:void(0)' key={innerData.dashboardId} onClick={() => onDashboardChange(innerData.dashboardId)} style={cursorPointerStyle} >
                                        {innerData.dashboardName}
                                    </a>
                                )}
                            </li>
                        </ul>
                    </div> : null}
                <div className='mg-l-5'>
                    <button className={`dropdown btn btn-sm btn-white tx-bold mg-t-2 mg-b-2 pos-relative`} type="button" style={{ fontSize: "13px" }} data-bs-toggle="dropdown"  ><i class="fa fa-ellipsis-h" aria-expanded="false" aria-hidden="true"></i>
                        {/* {propsData.dataSet.name} */}
                    </button>
                    <ul className="dropdown-menu" role="menu" id="breadcrumbDropdown">
                        {currentPageName == "alfred" ? <li className={`dropdown-item`} onClick={fetchSampleQuestions}>Download Questions</li> : null}
                        {/* <li className={`dropdown-item`} onClick={fetchSampleQuestions}>Download Questions</li> */}
                        <li className={`dropdown-item`} onClick={() => handleAlfred(propsData.dataSet)}>Refresh Dataset</li>
                        {/* {isPageNameValidForGlobalFilters ?
                            <li className={`dropdown-item`} onClick={() => handleGlobalFilter()}>Global Filter</li>
                            : null} */}
                    </ul>
                </div>
            </div>
            {/* {currentPageName == "pinboard" ? "" :
                <div className="btn-group">
                    <a className="btn-default" data-toggle="dropdown" id={`${propsData.allData.state.chartCat == '' || propsData.allData.state.chartCat == 'report' ? "aTagStyleactive" : "aTagStyle"}`}>
                        {getParameters('tab')=="dashboards" ? "dashboards" :  currentPageName == "pinboard"
                            ? 'dashboards'
                            : savedReportPage
                                ? 'saved reports'
                                : propsData.type == 'report'
                                    ? 'tables'
                                    : propsData.type}
                        <i className="fa fa-angle-right mg-l-5 mg-r-10"></i>
                    </a>
                    <ul className="dropdown-menu" role="menu" id="breadcrumbDropdown">
                        <li>
                            {Object.values(menu_array).map((innerData) =>
                                <a className={`dropdown-item ${innerData.label.toLowerCase() === propsData.type || (currentPageName && innerData.label === 'Dashboards') || (savedReportPage && innerData.label == 'Saved Reports') || (propsData.type == 'report' && innerData.label == 'Tables') ? 'active' : ""}`} href={innerData.link} onClick={() => setQuestion({ alfred_question: '' })} style={{cursor: "pointer" , fontSize :fontSizeCss} }  >
                                    {innerData.label}
                                </a>
                            )}
                        </li>
                    </ul>
                </div>
            } */}
            {propsData.type == "charts" && propsData.allData.state.chartCat != ''
                ? null
                // <div className="btn-group align-items-center ">
                //     <a className={`btn-default ${window.innerWidth <= mobile_width ? 'text-truncate wd-40':""}`} data-toggle="dropdown" id={"aTagStyleactive"} style={{fontSize : fontSizeCss}}>
                //         {chartData
                //             ? trimNameLength(propsData.allData.state.chartCat, window.innerWidth <= mobile_width ? 8 : 15)
                //             : spinnerSpan}
                //     </a>
                //     <i className="fa fa-angle-right mg-l-5" style={{ marginLeft: `${window.innerWidth <= mobile_width ? "-10px" : mobile ? "-10px" : ""}` }}></i>
                //     <ul className="dropdown-menu" role="menu" id="breadcrumbDropdown">
                //         <li>
                //             {chartData
                //                 ? Object.values(chartData).map((innerData) => {
                //                     let itemName, itemLink
                //                     if (innerData.name == 'Block') {
                //                         itemName = 'Summary'
                //                         itemLink = "/summary?nav=new"
                //                     } else {
                //                         itemName = innerData.name
                //                         itemLink = `/chart/chartData?chartCat=${innerData.name}&nav=new`
                //                     }
                //                     return <a className={`dropdown-item ${itemName === propsData.allData.state.chartCat ? 'active' : ""}`} href={itemLink} style={{cursor: "pointer" , fontSize :fontSizeCss} } onClick={() => handleAlfred(null, true)}>{itemName}</a>
                //                 })
                //                 : null}
                //         </li>
                //     </ul>
                // </div>
                : currentPageName == 'pinboard'
                    ? <>
                        {/* <div className="btn-group align-items-center"> */}
                            {/* <a className={`btn-default  ${datasetTruncate ? datasetTruncate :"" }`} data-toggle="dropdown" id="aTagStyle" style={{ cursorPointerStyle }} title={stateData.group}>
                                {stateData.group
                                    ? trimNameLength(stateData.group, mobile ? 2 : 15)
                                    : spinnerSpan}
                            </a>
                                <i className="fa fa-angle-right mg-l-5" style={{ marginLeft: `${window.innerWidth <= mobile_width ? "-10px" : mobile ? "-10px" : ""}` }}></i>
                            <ul className="dropdown-menu" role="menu" id="breadcrumbDropdown">
                                <li>
                                    {Object.values(menu_array['dashboard'].children).map((innerData) => {
                                        if (innerData.label == 'List')
                                            return
                                        else return <a className={`dropdown-item  ${innerData.label === stateData.group ? 'active' : ""}`} href={innerData.link} key={innerData.name} style={cursorPointerStyle} >{innerData.label}</a>
                                    }
                                    )}
                                </li>
                            </ul> */}
                        {/* </div> */}

                    </>
                    : null}
        </>
    )
}
function mapStateToProps(state) {
    return { dataa: { ...state.dataSet } };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setQuestion, setChartQuestion
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(BreadcrumbComponent);